<template>
  <v-card class="settings-card-primary add-edit-wrapper cost-per-record-form pa-7" id="const-per-record">
    <v-card-title style="font-weight: bold" class="pa-0"> {{ editMode }} Cost Per Record</v-card-title>
    <v-form class="w-100 mt-5" v-model="valid">
      <p class="input-label text-style">
        Select the industry your organization primarily fits within:
      </p>
      <v-select
          class="select-field"
          :menu-props="{ offsetY: true }"
          v-model="form.industry"
          required
          :rules="[rules.required]"
          :items="industries"
          item-text="industry"
          solo
          :loading="industriesLoading"
      >
      </v-select>
      <p class="input-label text-style">
        Select any of the regions in which you currently operate
      </p>
      <v-select
          class="select-field"
          :menu-props="{ offsetY: true }"
          v-model="form.global_regions"
          multiple
          :items="operationalRegions"
          item-text="region"
          solo
          :loading="businessOperationalRegionsLoading"
      >
      </v-select>
      <p class="input-label text-style">
        Select any of the regions in which you have customers
      </p>
      <v-select
          class="select-field"
          :menu-props="{ offsetY: true }"
          v-model="form.customer_regions"
          multiple
          :items="globalLocations"
          item-text="region"
          solo
          :loading="globalRegulationsLoading"
      >
      </v-select>
      <p class="input-label text-style">
        Revenue
      </p>
      <v-select
          class="select-field"
          v-model="form.revenue"
          required
          solo
          validate-on-blur
          :rules="[rules.required]"
          :items="bands"
          maxlength="8"
          @change="onRevenueChange"
      >
      </v-select>

      <p class="input-label text-style">
        Un-Adjusted Cost Per Record of a Cyber Event Remediation
      </p>
      <p>
        <strong>Min</strong> <span>${{form.unadj_cost_per_record_min}} per record</span>
        <strong class="ml-5">Max</strong> <span>${{form.unadj_cost_per_record_max}} per record</span>
        <v-progress-circular
            class="ml-5"
            :value="20"
            v-show="baselinesLoading"
            indeterminate
        ></v-progress-circular>
      </p>
      <p class="input-label text-style">
        Discount Factor
      </p>
      <v-slider
          class="select-field"
          v-model="form.discount_factor"
          :min="0"
          :max="100"
      ></v-slider>
      <p class="input-label text-style">
        Adjusted Cost Per Record of a Cyber Event Remediation
      </p>
      <p>
        <strong>Min</strong> <span>${{form.adj_cost_per_record_min}} per record</span>
        <strong class="ml-5">Max</strong> <span>${{form.adj_cost_per_record_max}} per record</span>
      </p>
    </v-form>
    <v-card-actions class="d-flex flex-column pa-0 pt-5">
      <v-spacer></v-spacer>
      <v-btn class="save-btn" text @click="saveCostPerRecordStudy()" :disabled="!valid">
        Save
      </v-btn>
      <v-btn class="cancel-btn" text @click="$router.push('/settings/cost-per-record-study')">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { BANDS } from '@/utils/constants'

export default {
  name: 'CostPerRecordStudyEditor',
  props: ['id'],
  data () {
    return {
      valid: false,
      editMode: 'Create',

      form: {
        industry: null,
        global_regions: null,
        customer_regions: null,
        revenue: '',

        unadj_cost_per_record_min: 0,
        unadj_cost_per_record_max: 0,

        discount_factor: 100,

        adj_cost_per_record_min: 0,
        adj_cost_per_record_max: 0
      },

      rules: {
        required: v => !!v || 'Required.'
      }
    }
  },
  computed: {
    ...mapGetters(['currentOrganization', 'activeCostPerRecordStudy', 'industries', 'businessOperationalRegions', 'globalRegulations', 'baselines', 'industriesLoading', 'businessOperationalRegionsLoading', 'globalRegulationsLoading', 'baselinesLoading', 'user']),
    bands () {
      return BANDS
    },
    operationalRegions () {
      return this.businessOperationalRegions.filter((item) => item.region !== 'and')
    },
    globalLocations () {
      return this.globalRegulations.filter((item) => item.region !== 'and')
    }
  },
  created () {
    if (this.id !== 'new') {
      this.editMode = 'Edit'
      this.$store.dispatch('loadActiveCostPerRecordStudy', this.id)
    } else {
      this.$store.dispatch('resetActiveCostPerRecordStudy')
    }

    this.industries.length || this.$store.dispatch('loadIndustries')
    this.businessOperationalRegions.length || this.$store.dispatch('loadBusinessOperationalRegions')
    this.globalRegulations.length || this.$store.dispatch('loadGlobalRegulations')
  },
  methods: {
    saveCostPerRecordStudy () {
      if (this.id === 'new') {
        this.form.date = this.$moment().format('M/D/YYYY')
        this.form.year = this.$moment().format('YYYY')
        this.form.organization_id = this.currentOrganization.entity_id
      }
      this.form.revenue = this.bands.indexOf(this.form.revenue)
      this.$store.dispatch('saveCostPerRecordStudy', { ...this.form })
      this.$router.push('/settings/cost-per-record-study')
    },

    async calculatedUnadjustedRecords () {
      console.log('aaaaa')
      this.baselines.length || await this.$store.dispatch('loadBaselines')

      const revenue = parseInt(this.form.revenue) * 1000000

      let baseline = null
      let prevThreshold = 0
      for (let i = 0; i < this.baselines.length; i++) {
        baseline = this.baselines[i]

        const threshold = parseInt(baseline.enterprise_min_rev_threshold)
        const nextThreshold = i < this.baselines.length - 1 ? parseInt(this.baselines[i + 1].enterprise_min_rev_threshold) : 0

        const ceil = (prevThreshold + threshold) / 2
        const floor = (threshold + nextThreshold) / 2

        if (revenue < ceil && revenue >= floor) {
          break
        }
        prevThreshold = threshold
      }

      if (revenue <= parseInt(baseline.enterprise_min_rev_threshold)) {
        this.form.unadj_cost_per_record_min = baseline.smb_cost_per_rcrd_median
        this.form.unadj_cost_per_record_max = baseline.smb_cost_per_rcrd_avg
      } else {
        this.form.unadj_cost_per_record_min = baseline.ent_cost_per_rcrd_median
        this.form.unadj_cost_per_record_max = baseline.ent_cost_per_rcrd_avg
      }
    },
    calculateAdjustedRecords () {
      this.form.adj_cost_per_record_min = this.form.unadj_cost_per_record_min * this.form.discount_factor / 100
      this.form.adj_cost_per_record_max = this.form.unadj_cost_per_record_max * this.form.discount_factor / 100
    },

    async onRevenueChange () {
      console.log('bbbbbbbb')
      await this.calculatedUnadjustedRecords()
      this.calculateAdjustedRecords()
    }
  },
  watch: {
    activeCostPerRecordStudy () {
      this.form = { ...this.activeCostPerRecordStudy }
    },
    'form.discount_factor' () {
      this.calculateAdjustedRecords()
    }
  }
}
</script>
